import { Banner } from '@packages/ui/layout';
import { TenantType } from '../../constants/common';
import useGetCurrentTenantInfo from '../../hooks/get/useGetCurrentTenantInfo';
import { useWealthlaneCustomerApi } from '../../hooks';

interface InstanceScopeBannerProps {
  semanticId?: string;
  className?: string;
}

const InstanceScopeBanner = ({
  semanticId = 'instanceScopeBanner',
  className,
}: InstanceScopeBannerProps): JSX.Element => {
  const { handleRequest } = useWealthlaneCustomerApi();
  const { data: tenantInfo } = useGetCurrentTenantInfo(handleRequest);

  const isSandbox = tenantInfo?.tenantType === TenantType.SANDBOX;
  const environmentLabel = isSandbox ? 'sandbox instance' : 'main production instance';
  const tenantName = tenantInfo?.name?.trim();

  return (
    <Banner variant='info' semanticId={semanticId} className={className}>
      <strong>Instance-level settings.</strong> You are managing the{' '}
      {tenantName != null && tenantName !== '' ? (
        <>
          <strong>{tenantName}</strong> {environmentLabel}
        </>
      ) : (
        environmentLabel
      )}
      . Changes made here apply only to this instance environment and do not affect company-level
      users or roles.
    </Banner>
  );
};

export default InstanceScopeBanner;
